<agr-summary-card [title]="'cropFieldsMap' | translate" class="map-summary-card">
  <app-agr-geo [customLayerMenuItems]="layerMenuItems" content></app-agr-geo>
</agr-summary-card>
